import { TopBannerBuilderComponent } from '@tvlgiao/bc-supermarket-builder-components';
import React from 'react';
export default {
  TopBannerBuilderComponent,
  React
};